import { render } from "./List-Order.vue?vue&type=template&id=7e33f372"
import script from "./List-Order.vue?vue&type=script&lang=js"
export * from "./List-Order.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\toko-masjid\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QMarkupTable from 'quasar/src/components/markup-table/QMarkupTable.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QSpinnerGears from 'quasar/src/components/spinner/QSpinnerGears.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QDate from 'quasar/src/components/date/QDate.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QBtn,QMarkupTable,QInput,QIcon,QInnerLoading,QSpinnerGears,QDialog,QImg,QScrollArea,QCardActions,QSelect,QItem,QItemSection,QItemLabel,QToggle,QPopupProxy,QDate});qInstall(script, 'directives', {ClosePopup});
